import React from "react";
import "./AboutUsGallery.css";

const teamMembers = [
  {
    name: "Guide Team",
    image: "https://twintravelcoron.com/team.jpeg",
    description:
      "Our team of expert guides is dedicated to creating immersive and unforgettable travel experiences. With in-depth knowledge of destinations and a passion for exploration, they ensure every journey is seamless and enriching.",
  },
  {
    name: "Boat Crew",
    image: "https://twintravelcoron.com/team2.jpeg",
    description:
      "Our skilled boat crew is committed to providing a safe and comfortable journey on the water. With years of experience and expert navigation, they ensure smooth sailing for every adventure.",
  },
  {
    name: "Boat Captain Team",
    image: "https://twintravelcoron.com/team3.jpeg",
    description:
      "Our experienced boat captains lead every voyage with precision and care. With their deep understanding of the waters and dedication to safety, they make every trip secure, smooth, and truly unforgettable.",
  },
];

const AboutUsGallery = () => {
  return (
    <div className="aboutUsGallery">
      <div className="containerGallery">
        {teamMembers.map((member, index) => (
          <div
            className={`galleryItem ${index % 2 !== 0 ? "reverse" : ""}`}
            key={index}
          >
            <div className="galleryImage">
              <img src={member.image} alt={member.name} loading="lazy" />
            </div>
            <div className="galleryText">
              <h3>{member.name}</h3>
              <p>{member.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUsGallery;
